module.exports = __webpack_public_path__ + "media/images/icons/icon-milestones-fa0199a223605785318233e97c341b00.svg";